// Charge la base commune
import './common.js'

// Styles custom
import './scss/pages/realisations.scss'

// Scripts librairies
import 'bootstrap/js/dist/carousel'
import { dtectMap } from './js/libs/utils'

// Grounds Map
async function getRealisationsMap ($f) {
  $f.load()
  import(/* webpackChunkName: "realisationsMap", webpackPrefetch: true */ './js/components/realisationsMap.js').then(() => {
    $f.load(false)
  })
}

// MagnificPopup
async function getMagnificPopup () {
  import(/* webpackChunkName: "magnificPopup" */ './js/components/magnificPopup.js')
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion image popup
  const $i = $('.image-popup-gallery, .image-popup-only')
  if ($i.length) {
    $i.waypoint(function () {
      getMagnificPopup()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // wait until gmap is correctly loading
  dtectMap(function () {
    // gestion de la carte des programmes
    const $m = $('#realisations-map')
    $m.waypoint(function () {
      getRealisationsMap($m)
      this.destroy()
    }, {
      offset: '100%'
    })
  })

  // gestion d'une ancre
  if ($('#go').length) {
    const t = $('#go')
    $('html, body').animate({
      scrollTop: ($(t).offset().top - 120) - -1
    }, 300)
  }
})
